<template>
  <div>
    <el-dialog
      :visible.sync="navVisible"
      :title="$t('components_my_navbar_index_2369')"
      v-dialogDrag
      style="padding-bottom: 20px"
      class="tableData my_navbar"
      append-to-body
      :close-on-click-modal="false"
      width="860px"
      @close="close_dialog"
    >
      <div class="tableDatapart">
        <div class="addNavPart">
          <p class="title">{{$t('components_my_navbar_index_2370')}}</p>
          <el-button size="small" @click="showpoppart('')">{{$t('components_my_navbar_index_2371')}}</el-button>
        </div>
        <div class="headerLine">
          <!-- <span>id</span> -->
          <span class="ce_1 firstLine">{{$t('base_options_config_1724')}}</span>
          <span class="ce_2">{{$t('components_my_navbar_page_setting')}}<el-tooltip popper-class="item-tip" :content="$t('components_my_navbar_page_setting_tip')" placement="top"><i class="el-icon-question" style="margin-left:4px;cursor:pointer;"></i></el-tooltip></span>
          <span class="ce_2_show">{{$t('view_form_dialog_add_form_213')}}<el-tooltip popper-class="item-tip" :content="$t('components_my_navbar_show_setting_tip')" placement="top"><i class="el-icon-question" style="margin-left:4px;cursor:pointer;"></i></el-tooltip></span>
          <span class="ce_3">{{$t('view_form_dialog_add_form_215')}}</span>
          <span class="ce_4">{{$t('view_form_dialog_add_form_216')}}</span>
        </div>
      </div>
      <ul class="navToppart" id="navToppart">
        <li
          class="navTopline"
          :class="{ dropLi: sysVersion == '3' }"
          v-for="(parentVal, parentIndex) in tableData"
          :key="parentIndex"
        >
          <div
            class="linePart sortLine"
            :class="{ system: parentVal.is_system == '' }"
            @mousedown="mousedown_parentIndex(parentIndex, $event)"
            @mouseup="clearData"
          >
            <div class="contentPart"></div>
            <input
              type="hidden"
              class="disabled"
              v-model="parentVal.disabled"
            />
            <input type="hidden" class="icon" v-model="parentVal.icon" />
            <input type="hidden" class="id" v-model="parentVal.id" />
            <input type="hidden" class="tid" v-model="parentVal.tid" />
            <input
              type="hidden"
              class="is_system"
              v-model="parentVal.is_system"
            />
            <input
              type="hidden"
              class="isopenwindow"
              v-model="parentVal.isopenwindow"
            />
            <input type="hidden" class="link" v-model="parentVal.link" />
            <input type="hidden" class="module" v-model="parentVal.module" />
            <input type="hidden" class="name" v-model="parentVal.name" />
            <input type="hidden" class="nofol" v-model="parentVal.nofol" />
            <input type="hidden" class="pid" v-model="parentVal.pid" />
            <input type="hidden" class="seq" v-model="parentVal.seq" />
            <input
              type="hidden"
              class="childShow"
              v-model="parentVal.childShow"
            />
            <input
              type="hidden"
              class="other_name"
              v-model="parentVal.other_name"
            />
            <!--          <span class="id">
              {{ parentVal.id }}
            </span>-->
            <div class="title ce_1" style="width: 215px">
              <div class="stopPart" @mousedown.stop>
                <i
                  v-if="parentVal.children && parentVal.children.length != 0"
                  :class="
                    parentVal.childShow == 'false'
                      ? 'el-icon-caret-right'
                      : 'el-icon-caret-bottom'
                  "
                  style="padding-right: 5px"
                  @click="changeChildshow(parentIndex)"
                ></i>
              </div>
              <span>{{ parentVal.name }}</span>
            </div>
            <div class="ce_2">
              <div class="switch-icon" @mousedown.stop>
                <b
                  :class="
                    parentVal.disabled == 'false'
                      ? 'el-icon-check'
                      : 'el-icon-close'
                  "
                  style="cursor: pointer"
                  @click="changeSwitch('hide', parentVal)"
                ></b>
              </div>
              <!-- <el-switch
              v-model="parentVal.disabled"
              active-color="#13ce66"
              inactive-color="#DCDFE6"
              active-value="false"
              inactive-value="true"
              active-icon-class='el-icon-check'
              inactive-icon-class='el-icon-close'
              @change="changeSwitch('hide', parentVal)"
              ></el-switch>-->
            </div>
            <div class="ce_2_show">
              <div class="switch-icon" @mousedown.stop>
                <b
                  :class="
                    parentVal.show_in_nav == 'true'
                      ? 'el-icon-check'
                      : 'el-icon-close'
                  "
                  :style="parentVal.disabled == 'true' ? 'cursor: not-allowed; opacity: 0.4; pointer-events: none;' : 'cursor: pointer;'"
                  @click="changeSwitch('show_in_nav', parentVal)"
                ></b>
              </div>
            </div>
            <div class="ce_3">
              <div class="el-icon-btn" @mousedown.stop v-if="parentIndex != 0">
                <a
                  class="el-icon-top"
                  @click="changeParentTop(parentVal, parentIndex)"
                ></a>
              </div>
              <div
                class="el-icon-btn"
                @mousedown.stop
                v-if="parentIndex != tableData.length - 1"
              >
                <a
                  class="el-icon-bottom"
                  @click="changeParentBottom(parentVal, parentIndex)"
                ></a>
              </div>
              <div
                class="el-icon-btn"
                @mousedown.stop
                v-if="
                  parentIndex != 0 &&
                  parentVal.children &&
                  parentVal.children.length == 0"
              >
                <a
                  class="el-icon-right"
                  @click="changeParentRight(parentVal, parentIndex)"
                ></a>
              </div>
            </div>
            <!-- <span>
              <el-switch
                v-model="parentVal.isopenwindow"
                active-color="#13ce66"
                inactive-color="#DCDFE6"
                active-value="true"
                inactive-value="false"
                :active-text="parentVal.isopenwindow == 'true' ? '开启' : '关闭'"
                @change="changeSwitch('isopenwindow', parentVal)"
              ></el-switch>
            </span>-->
            <div class="contorlPart ce_4">
              <div
                @mousedown.stop
                class="iconPart"
                v-if="parentVal.theme_name == 'anchor'"
              >
                <el-tooltip
                  class="item diseditIcon"
                  effect="light"
                  :content="'“' + parentVal.name + $t('components_my_navbar_index_2372')"
                  placement="top"
                >
                  <span></span>
                </el-tooltip>
              </div>
              <div @mousedown.stop class="iconPart" v-else>
                <span
                  @click="
                    showpoppart(
                      parentVal,
                      'edit',
                      parentVal.is_system == 'false'
                    )
                  "
                  class="editIcon"
                  :title="$t('components_basic_addarticle_index_2003')"
                ></span>
              </div>

              <div
                @mousedown.stop
                class="iconPart"
                v-if="parentVal.theme_name == 'anchor'"
              >
                <el-tooltip
                  class="item discopyIcon"
                  effect="light"
                  :content="'“' + parentVal.name + $t('components_my_navbar_index_2373')"
                  placement="top"
                >
                  <span></span>
                </el-tooltip>
              </div>
              <div
                @mousedown.stop
                class="iconPart"
                v-else-if="parentVal.is_system == 'false'"
              >
                <span
                  @click="
                    showpoppart(
                      parentVal,
                      'copy',
                      parentVal.is_system == 'false'
                    )
                  "
                  class="copyIcon"
                  :title="$t('components_ai_command_tkd_1967')"
                ></span>
              </div>
              <div @mousedown.stop class="iconPart" v-else>
                <el-tooltip
                  class="item discopyIcon"
                  effect="light"
                  :content="'“' + parentVal.name + $t('components_my_navbar_index_2374')"
                  placement="top"
                >
                  <span></span>
                </el-tooltip>
              </div>
              <div @mousedown.stop class="iconPart">
                <span
                  v-if="
                    parentVal.module == 'index:index'
                    || parentVal.module.indexOf('p:') == 0
                    || parentVal.module == 'anchor'
                    || parentVal.module == ''"
                  @click="
                    showpoppart(
                      parentVal,
                      'add',
                      parentVal.is_system == 'false'
                    )
                  "
                  class="addIcon"
                  :title="$t('components_basic_addarticle_index_2004')"
                ></span>
                <span
                  v-else
                  class="disaddIcon"
                  style="cursor: not-allowed"
                  :title="$t('components_basic_addarticle_index_2004')"
                ></span>
              </div>
              <!-- 现有删除逻辑需要调整 -->
              <div
                @mousedown.stop
                class="iconPart"
                v-if="parentVal.is_system == 'false'"
              >
                <span
                  @click="deletePage(parentVal)"
                  class="deleteIcon"
                  :title="$t('view_god_set_index_226')"
                ></span>
              </div>
              <!-- <el-button type="text"><a :href="parentVal.link" target="_blank" class="el-button--text">查看</a></el-button> -->
              <div @mousedown.stop class="iconPart" v-else>
                <el-tooltip
                  class="item disdeleteIcon"
                  effect="light"
                  :content="'“' + parentVal.name + $t('components_my_navbar_index_2375')"
                  placement="top"
                >
                  <span></span>
                </el-tooltip>
              </div>
            </div>
          </div>
          <ul
            class="childPart"
            :style="{
              display: parentVal.childShow == 'false' ? 'none' : 'block',
            }"
          >
            <li
              class="navChildline"
              :class="{ dropLi: sysVersion == '3' }"
              v-for="(childVal, childIndex) in parentVal.children"
              :key="childIndex"
            >
              <div
                class="childLinepart sortLine"
                @mousedown="
                  mousedown_childIndex(parentIndex, childIndex, $event)
                "
              >
                <input
                  type="hidden"
                  class="disabled"
                  v-model="childVal.disabled"
                />
                <input type="hidden" class="icon" v-model="childVal.icon" />
                <input type="hidden" class="id" v-model="childVal.id" />
                <input type="hidden" class="tid" v-model="childVal.tid" />
                <input
                  type="hidden"
                  class="is_system"
                  v-model="childVal.is_system"
                />
                <input
                  type="hidden"
                  class="isopenwindow"
                  v-model="childVal.isopenwindow"
                />
                <input type="hidden" class="link" v-model="childVal.link" />
                <input type="hidden" class="module" v-model="childVal.module" />
                <input type="hidden" class="name" v-model="childVal.name" />
                <input type="hidden" class="nofol" v-model="childVal.nofol" />
                <input type="hidden" class="pid" v-model="childVal.pid" />
                <input type="hidden" class="seq" v-model="childVal.seq" />
                <input
                  type="hidden"
                  class="childShow"
                  v-model="childVal.childShow"
                />
                <input
                  type="hidden"
                  class="other_name"
                  v-model="childVal.other_name"
                />
                <!-- <span class="id">{{ childVal.id }}</span> -->
                <b class="childTagIcon"></b>
                <!-- <div class="title ce_1" style="width: 187px;">
                  <span>{{ childVal.name }}</span>
                </div> -->
                <div class="title ce_1">
                  <div class="stopPart" @mousedown.stop>
                    <i
                      v-if="childVal.children && childVal.children.length != 0"
                      :class="
                        childVal.childShow == 'false'
                          ? 'el-icon-caret-right'
                          : 'el-icon-caret-bottom'
                      "
                      style="padding-right: 5px"
                      @click="changeChildshow(parentIndex, childIndex)"
                    ></i>
                  </div>
                  <span>{{ childVal.name }}</span>
                </div>
                <div class="ce_2">
                  <div class="switch-icon" @mousedown.stop>
                    <b
                      :class="
                        childVal.disabled == 'false'
                          ? 'el-icon-check'
                          : 'el-icon-close'
                      "
                      style="cursor: pointer"
                      @click="changeSwitch('hide', childVal)"
                    ></b>
                  </div>
                  <!-- <el-switch
                  v-model="childVal.disabled"
                  active-color="#13ce66"
                  inactive-color="#DCDFE6"
                  active-value="false"
                  inactive-value="true"
                  :active-text="childVal.disabled == 'false' ? '开启' : '关闭'"
                  @change="changeSwitch('hide', childVal)"
                  ></el-switch>-->
                </div>
                <div class="ce_2_show">
                  <div class="switch-icon" @mousedown.stop>
                    <b
                      :class="
                        childVal.show_in_nav == 'true'
                          ? 'el-icon-check'
                          : 'el-icon-close'
                      "
                      :style="childVal.disabled == 'true' ? 'cursor: not-allowed; opacity: 0.4; pointer-events: none;' : 'cursor: pointer;'"
                      @click="changeSwitch('show_in_nav', childVal)"
                    ></b>
                  </div>
                </div>
                <div class="ce_3">
                  <div
                    class="el-icon-btn"
                    @mousedown.stop
                    v-if="childIndex != 0"
                  >
                    <a
                      class="el-icon-top"
                      @click="changeChildTop(parentIndex, childIndex, childVal)"
                    ></a>
                  </div>
                  <div
                    class="el-icon-btn"
                    @mousedown.stop
                    v-if="childIndex != parentVal.children.length - 1"
                  >
                    <a
                      class="el-icon-bottom"
                      @click="
                        changeChildBottom(parentIndex, childIndex, childVal)
                      "
                    ></a>
                  </div>
                  <div class="el-icon-btn" @mousedown.stop>
                    <a
                      class="el-icon-back"
                      @click="
                        changeChildBack(parentIndex, childIndex, childVal)
                      "
                    ></a>
                  </div>
                  <div
                    class="el-icon-btn"
                    @mousedown.stop
                    v-if="
                      childIndex != 0 &&
                      childVal.children &&
                      childVal.children.length == 0
                      && (childVal.module == 'index:index'
                      || childVal.module == 'anchor'
                      || childVal.module.indexOf('p:') == 0
                      || childVal.module == '')
                    "
                  >
                    <a
                      class="el-icon-right"
                      @click="
                        changeChildRight(parentIndex, childVal, childIndex)
                      "
                    ></a>
                  </div>
                </div>
                <!--              <span>
                <el-switch
                  v-model="childVal.isopenwindow"
                  active-color="#13ce66"
                  inactive-color="#DCDFE6"
                  active-value="true"
                  inactive-value="false"
                  :active-text="childVal.isopenwindow == 'true' ? '开启' : '关闭'"
                  @change="changeSwitch('isopenwindow', childVal)"
                ></el-switch>
                </span>-->
                <div class="ce_4 contorlPart">
                  <div
                    @mousedown.stop
                    class="iconPart"
                    v-if="childVal.theme_name == 'anchor'"
                  >
                    <el-tooltip
                      class="item diseditIcon"
                      effect="light"
                      :content="'“' + childVal.name + $t('components_my_navbar_index_2372')"
                      placement="top"
                    >
                      <span></span>
                    </el-tooltip>
                  </div>
                  <div @mousedown.stop class="iconPart" v-else>
                    <span
                      @click="
                        showpoppart(
                          childVal,
                          'edit',
                          childVal.is_system == 'false'
                        )
                      "
                      class="editIcon"
                      :title="$t('components_basic_addarticle_index_2003')"
                    ></span>
                  </div>

                  <div
                    @mousedown.stop
                    class="iconPart"
                    v-if="childVal.theme_name == 'anchor'"
                  >
                    <el-tooltip
                      class="item discopyIcon"
                      effect="light"
                      :content="'“' + childVal.name + $t('components_my_navbar_index_2373')"
                      placement="top"
                    >
                      <span></span>
                    </el-tooltip>
                  </div>
                  <div
                    @mousedown.stop
                    class="iconPart"
                    v-else-if="childVal.is_system == 'false'"
                  >
                    <span
                      @click="
                        showpoppart(
                          childVal,
                          'copy',
                          childVal.is_system == 'false'
                        )
                      "
                      class="copyIcon"
                      :title="$t('components_ai_command_tkd_1967')"
                    ></span>
                  </div>
                  <div @mousedown.stop class="iconPart" v-else>
                    <el-tooltip
                      class="item discopyIcon"
                      effect="light"
                      :content="'“' + childVal.name + $t('components_my_navbar_index_2374')"
                      placement="top"
                    >
                      <span></span>
                    </el-tooltip>
                  </div>
                  <div @mousedown.stop class="iconPart">
                    <span
                      v-if="
                        childVal.module == 'index:index' ||
                        childVal.module == '' ||
                        childVal.module == 'anchor' ||
                        childVal.module.indexOf('p:') == 0"
                      class="addIcon"
                      @click="showpoppart(childVal, 'add')"
                      :title="$t('components_basic_addarticle_index_2004')"
                    ></span>
                    <span
                    v-else
                      class="disaddIcon"
                      style="cursor: not-allowed"
                      :title="$t('components_basic_addarticle_index_2004')"
                    ></span>
                  </div>
                  <!-- 现有删除逻辑需要调整 -->
                  <div
                    @mousedown.stop
                    class="iconPart"
                    v-if="childVal.is_system == 'false'"
                  >
                    <span
                      @click="deletePage(childVal)"
                      class="deleteIcon"
                      :title="$t('view_god_set_index_226')"
                    ></span>
                  </div>
                  <!-- <el-button type="text"><a :href="childVal.link" target="_blank" class="el-button--text">查看</a></el-button> -->
                  <div @mousedown.stop class="iconPart" v-else>
                    <el-tooltip
                      class="item disdeleteIcon"
                      effect="light"
                      :content="'“' + childVal.name + $t('components_my_navbar_index_2375')"
                      placement="top"
                    >
                      <span></span>
                    </el-tooltip>
                  </div>
                </div>
              </div>
              <ul
                class="child2Part"
                :style="{
                  display: childVal.childShow == 'false' ? 'none' : 'block',
                }"
              >
                <li
                  class="navChildline"
                  :class="{ dropLi: sysVersion == '3' }"
                  v-for="(sonVal, sonIndex) in childVal.children"
                  :key="sonIndex"
                >
                  <div
                    class="childLinepart sortLine"
                    @mousedown="
                      mousedown_childIndex(childIndex, sonIndex, $event)
                    "
                  >
                    <input
                      type="hidden"
                      class="disabled"
                      v-model="sonVal.disabled"
                    />
                    <input type="hidden" class="icon" v-model="sonVal.icon" />
                    <input type="hidden" class="id" v-model="sonVal.id" />
                    <input type="hidden" class="tid" v-model="sonVal.tid" />
                    <input
                      type="hidden"
                      class="is_system"
                      v-model="sonVal.is_system"
                    />
                    <input
                      type="hidden"
                      class="isopenwindow"
                      v-model="sonVal.isopenwindow"
                    />
                    <input type="hidden" class="link" v-model="sonVal.link" />
                    <input
                      type="hidden"
                      class="module"
                      v-model="sonVal.module"
                    />
                    <input type="hidden" class="name" v-model="sonVal.name" />
                    <input type="hidden" class="nofol" v-model="sonVal.nofol" />
                    <input type="hidden" class="pid" v-model="sonVal.pid" />
                    <input type="hidden" class="seq" v-model="sonVal.seq" />
                    <input
                      type="hidden"
                      class="other_name"
                      v-model="sonVal.other_name"
                    />
                    <b class="childTagIcon"></b>
                    <div class="title ce_1" style="width: 175px">
                      <span>{{ sonVal.name }}</span>
                    </div>
                    <div class="ce_2">
                      <div class="switch-icon" @mousedown.stop>
                        <b
                          :class="
                            sonVal.disabled == 'false'
                              ? 'el-icon-check'
                              : 'el-icon-close'
                          "
                          style="cursor: pointer"
                          @click="changeSwitch('hide', sonVal)"
                        ></b>
                      </div>
                    </div>
                    <div class="ce_2_show">
                      <div class="switch-icon" @mousedown.stop>
                        <b
                          :class="
                            sonVal.show_in_nav == 'true'
                              ? 'el-icon-check'
                              : 'el-icon-close'
                          "
                          :style="sonVal.disabled == 'true' ? 'cursor: not-allowed; opacity: 0.4; pointer-events: none;' : 'cursor: pointer;'"
                          @click="changeSwitch('show_in_nav', sonVal)"
                        ></b>
                      </div>
                    </div>
                    <div class="ce_3">
                      <div
                        class="el-icon-btn"
                        @mousedown.stop
                        v-if="sonIndex != 0"
                      >
                        <a
                          class="el-icon-top"
                          @click="
                            changeChild2Top(
                              parentIndex,
                              childIndex,
                              sonIndex,
                              sonVal
                            )
                          "
                        ></a>
                      </div>
                      <div
                        class="el-icon-btn"
                        @mousedown.stop
                        v-if="sonIndex != childVal.children.length - 1"
                      >
                        <a
                          class="el-icon-bottom"
                          @click="
                            changeChild2Bottom(
                              parentIndex,
                              childIndex,
                              sonIndex,
                              sonVal
                            )
                          "
                        ></a>
                      </div>
                      <div class="el-icon-btn" @mousedown.stop>
                        <a
                          class="el-icon-back"
                          @click="
                            changeChild2Back(
                              parentIndex,
                              childIndex,
                              sonIndex,
                              sonVal
                            )
                          "
                        ></a>
                      </div>
                    </div>
                    <div class="ce_4 contorlPart">
                      <div
                        @mousedown.stop
                        class="iconPart"
                        v-if="sonVal.theme_name == 'anchor'"
                      >
                        <el-tooltip
                          class="item diseditIcon"
                          effect="light"
                          :content="
                            '“' + sonVal.name + $t('components_my_navbar_index_2372')
                          "
                          placement="top"
                        >
                          <span></span>
                        </el-tooltip>
                      </div>
                      <div @mousedown.stop class="iconPart" v-else>
                        <span
                          @click="
                            showpoppart(
                              sonVal,
                              'edit',
                              sonVal.is_system == 'false'
                            )
                          "
                          class="editIcon"
                          :title="$t('components_basic_addarticle_index_2003')"
                        ></span>
                      </div>

                      <div
                        @mousedown.stop
                        class="iconPart"
                        v-if="sonVal.theme_name == 'anchor'"
                      >
                        <el-tooltip
                          class="item discopyIcon"
                          effect="light"
                          :content="
                            '“' + sonVal.name + $t('components_my_navbar_index_2373')
                          "
                          placement="top"
                        >
                          <span></span>
                        </el-tooltip>
                      </div>
                      <div
                        @mousedown.stop
                        class="iconPart"
                        v-else-if="sonVal.is_system == 'false'"
                      >
                        <span
                          @click="
                            showpoppart(
                              sonVal,
                              'copy',
                              sonVal.is_system == 'false'
                            )
                          "
                          class="copyIcon"
                          :title="$t('components_ai_command_tkd_1967')"
                        ></span>
                      </div>
                      <div @mousedown.stop class="iconPart" v-else>
                        <el-tooltip
                          class="item discopyIcon"
                          effect="light"
                          :content="
                            '“' + sonVal.name + $t('components_my_navbar_index_2374')
                          "
                          placement="top"
                        >
                          <span></span>
                        </el-tooltip>
                      </div>
                      <div @mousedown.stop class="iconPart">
                        <span
                          class="disaddIcon"
                          style="cursor: not-allowed"
                          :title="$t('components_basic_addarticle_index_2004')"
                        ></span>
                      </div>
                      <!-- 现有删除逻辑需要调整 -->
                      <div
                        @mousedown.stop
                        class="iconPart"
                        v-if="sonVal.is_system == 'false'"
                      >
                        <span
                          @click="deletePage(sonVal)"
                          class="deleteIcon"
                          :title="$t('view_god_set_index_226')"
                        ></span>
                      </div>
                      <div @mousedown.stop class="iconPart" v-else>
                        <el-tooltip
                          class="item disdeleteIcon"
                          effect="light"
                          :content="
                            '“' + sonVal.name + $t('components_my_navbar_index_2375')
                          "
                          placement="top"
                        >
                          <span></span>
                        </el-tooltip>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
      <div class="countPart">
        <p>{{$t('components_basic_management_index_2182', [ count ])}}</p>
      </div>
      <!-- <div slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="closePop" :disabled="navVisibleDisabled">确 定</el-button>
        <el-button size="small" @click="close_dialog">取 消</el-button>
      </div> -->
    </el-dialog>
    <el-dialog
      :title="titleWords"
      :visible.sync="dialogFormVisible"
      v-if="dialogFormVisible"
      width="640px"
      class="my_navbar"
      append-to-body
      v-dialogDrag
      :close-on-click-modal="false"
      @close="close_item_dialog"
    >
      <div v-loading="loading2">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="140px"
          class="ruleFormStyle el-form-self-check"
        >
          <el-form-item :label="$t('components_my_navbar_index_2376')" class="formItem add0" required>
            <el-radio-group
              v-model="ruleForm.pageType"
              @change="changePage(ruleForm.pageType)"
              :disabled="!editId ? false : true"
            >
              <el-radio label="page">{{$t('components_my_navbar_index_2377')}}</el-radio>
              <el-radio label="link">{{$t('components_my_empty_tips_index_2304')}}</el-radio>
            </el-radio-group>
          </el-form-item>

          <div class="step_1" ref="step_1">
            <el-form-item :label="$t('components_my_navbar_index_2378')" prop="title">
              <el-input
                v-model="ruleForm.title"
                :placeholder="$t('components_my_navbar_index_2379')"
                @change="setSeoTitle(ruleForm.title)"
              ></el-input>
            </el-form-item>
            <staticTips :marginLeft="140" :marginTop="-14" :typeName="'nav.title'"></staticTips>

            <el-form-item :label="$t('components_my_navbar_index_2380')" label-width="150px" v-if="editId == ''" prop="pid">
              <el-select
                transfer="true"    
                popper-class="label-select"
                :popper-append-to-body="false"
                :data-id="ruleForm.pid"
                v-model="ruleForm.pid"
                :placeholder="$t('components_basic_addproduct_message_2101')"
                class="area"
                clearable
              >
                <el-option
                  v-for="item in $store.state.app.twoLevelNavList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.name"
                >
                <span>{{item.display_name}}{{ item.name }}</span>
                </el-option>
              </el-select>
            </el-form-item>


            <el-form-item
              v-if="ruleForm.pageType != 'page'"
              key="link_keys"
              :label="$t('components_my_navbar_index_2381')"
              prop="link"
              class="formItem"
            >
              <el-input
                v-model="ruleForm.link"
                :placeholder="$t('components_my_navbar_index_2382')"
              ></el-input>
            </el-form-item>

            <!--
            <el-form-item label="栏目副标题：" prop="other_name">
              <el-input
                v-model="ruleForm.other_name"
                placeholder="请输入栏目副标题"
              ></el-input>
            </el-form-item>
            -->
            <el-form-item :label="$t('components_basic_addarticle_message_2028')" prop="static" 
            v-if="(ruleForm.module && ruleForm.module != 'index:index') 
            || typeof ruleForm.module == 'undefined'">
                <el-input v-model="ruleForm.static" :placeholder="$store.state.app.static_placeholder" @blur="staticBlur"></el-input>
            </el-form-item>

            <staticTips v-if="(ruleForm.module && ruleForm.module != 'index:index') 
            || typeof ruleForm.module == 'undefined'" :marginLeft="140" :marginTop="-14" :typeName="'static'"></staticTips>
            
            <el-form-item
              :label="$t('components_my_navbar_index_2383')"
              prop="scrollType"
              label-width="154px"
              v-if="shouldScrollTypeShow"
              
            >
              <div class="setting-img-group setting-scroll-type">
                <div
                  class="setting-img-item"
                  v-for="(item, i) in $store.state.options.scrollType"
                  :key="i"
                  @click="onClickScrollType(item)"
                  @mouseenter="onMouseEnter(item, i)"
                  @mouseleave="onMouseLeave(item)"
                >
                  <label
                    class="setting-img-label"
                    :class="
                      ruleForm.scroll_type == item.value
                        ? 'img-label-checked'
                        : ''
                    "
                  >
                    <div
                      class="jz_style_img style_item_img"
                      :class="['jz_style_img_' + i + ' style_item_' + i]"
                    >
                      <img
                        v-if="item.sampleImgVisible"
                        class="gif-sample"
                        :src="item.sampleImgUrl"
                        alt="sample"
                      />
                    </div>
                  </label>
                  <p class="setting-img-text">{{ $t(item.label) }}</p>
                </div>
              </div>
            </el-form-item>

            <el-form-item v-if="ruleForm.module !=='anchor'" :label="$t('components_my_navbar_index_2384')" prop="icon">
              <div
                class="avatar-uploader-part"
                v-if="ruleForm.icon == '' || ruleForm.icon == null"
                @click="showpop"
              >
                <i class="el-icon-circle-plus avatar-uploader-icon"></i>
                <p>{{$t('components_basic_addarticle_message_2055')}}</p>
              </div>
              <div class="avatar-uploader-part-new imgPart" v-else>
                <my_img_cover :firstModel.sync="ruleForm.icon"></my_img_cover>
                <a
                  class="close-avatar-uploader el-icon-circle-close"
                  @click="delImg"
                ></a>
                <img :src="ruleForm.icon" class="avatar" />
              </div>
            </el-form-item>
            <staticTips :marginLeft="140" :marginTop="-30" :typeName="'nav.img'"></staticTips>

            <el-form-item :label="$t('components_my_navbar_index_2385')" prop="window">
              <el-radio-group v-model="ruleForm.window">
                <el-radio label="false">{{$t('view_left_sidebar_setting_292')}}</el-radio>
                <el-radio label="true">{{$t('view_left_sidebar_setting_293')}}</el-radio>
              </el-radio-group>
            </el-form-item>
            <!--
            <el-form-item label="排序：" prop="sort" class="hints">
                <el-input
                  v-model.number="ruleForm.sort"
                  placeholder="请输入排序"
                  controls-position="right"
                  :min="0"
                  type="number"
                  :max="99999"
                ></el-input>
              </el-form-item>
              <staticTips :marginLeft="140" :marginTop="-15" content="排序值范围为0~99999"></staticTips>
              -->

            <el-form-item :label="$t('components_my_navbar_index_2386')" prop="hidden">
              <el-radio-group v-model="ruleForm.hidden" class="hideDisplay">
                <el-radio label="false">{{$t('view_form_dialog_add_form_213')}}</el-radio>
                <el-radio label="true">{{$t('view_back_top_index_105')}}</el-radio>
              </el-radio-group>
            </el-form-item>
            
            

            <!--
            <el-form-item
              v-if="ruleForm.pageType != 'link' && !editId"
              label="页面名称："
              prop="pageName"
              class="formItem"
            >
              <el-input
                v-model="ruleForm.pageName"
                placeholder="请输入页面名称(必须是英文或数字)"
              ></el-input>
            </el-form-item>
            -->
            
            <el-form-item :label="$t('components_my_navbar_index_2387')" prop="nofollow">
              <el-radio-group v-model="ruleForm.nofollow">
                <el-radio :label="1">{{$t('components_my_navbar_index_2388')}}</el-radio>
                <el-radio :label="0">{{$t('widgets_basic_article_info_edit_353')}}</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
          <div class="step_2" ref="step_2" v-if="ruleForm.pageType != 'link'">

         <seo ref="infoSeo" :seoData="ruleForm.seo" :seoType="'nav'" ></seo>

            <!--
            <el-form-item label="SEO标题：" prop="seo.seo_title">
              <el-input
                v-model="ruleForm.seo.seo_title"
                placeholder="请输入SEO标题"
                class="input-with-select"
                v-if="ruleForm.radioSet == 1"
                :disabled="ruleForm.radioSet == 1"
              ></el-input>
              <el-input
                v-if="ruleForm.radioSet == 2"
                type="text"
                placeholder="请输入SEO标题"
                @input="changeHanderseo('title', $event)"
                v-model="ruleForm.seo.seo_title"
              ></el-input>
            </el-form-item>
            <staticTips v-if="ruleForm.radioSet == 2" :marginLeft="140" :content="$store.state.app.seo_title_tips"></staticTips>
              <div class="keyword-list">
                <el-form-item label="SEO关键词：">
                  <div style="width:440px" :class="ruleForm.seo.keywords.length - 1 !== index ? 'keyword-contain keyword-contain-not-last' : 'keyword-contain'" v-for="(keyword, index) in ruleForm.seo.keywords" :key="index">
                    <el-input
                      v-if="ruleForm.radioSet == 1"
                      :maxlength="60"
                      v-model.trim="keyword.value"
                      placeholder="请输入SEO关键词"
                      class="input-with-select"
                      :disabled="ruleForm.radioSet == 1"
                    ></el-input>
                    <el-input
                      v-if="ruleForm.radioSet == 2"
                      type="text"
                      :maxlength="60"
                      placeholder="请输入SEO关键词"
                      @input="changeHanderseo('keywords', $event)"
                      v-model.trim="keyword.value"
                    ></el-input>
                    <el-tooltip class="item" effect="dark" content="添加" placement="bottom">
                      <i
                      @click="add_keywords"
                        class="el-icon-circle-plus-outline add_icon"
                        v-if="ruleForm.seo.keywords.length - 1 == index && ruleForm.seo.keywords.length < 5"
                      ></i>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
                      <i class="del_btn" v-if="index !== 0" @click="del_keywords(index)">
                        <i class="del_btn el-icon-delete" v-if="index !== 0" @click="del_keywords(index)"></i>
                      </i>
                    </el-tooltip>
                  </div>
                </el-form-item>
              </div>
              <staticTips v-if="ruleForm.radioSet == 2" :marginLeft="140" :content="$store.state.app.seo_keywords_tips"></staticTips>

            <el-form-item label="SEO描述：" prop="seo.describe">
              <el-input
                v-if="ruleForm.radioSet == 1"
                :disabled="ruleForm.radioSet == 1"
                v-model="ruleForm.seo.describe"
                placeholder="请输入SEO描述"
                class="input-with-select"
              ></el-input>

              <el-input
                v-if="ruleForm.radioSet == 2"
                type="textarea"
                placeholder="请输入SEO描述"
                @input="changeHanderseo('description', $event)"
                v-model="ruleForm.seo.describe"
              ></el-input>
            </el-form-item>
            <staticTips v-if="ruleForm.radioSet == 2" :marginLeft="140" :content="$store.state.app.seo_description_tips"></staticTips>
            -->

          </div>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          size="small"
          type="primary"
          @click="submitForm('ruleForm')"
          :disabled="ruleFormDisabled"
          >{{$t('view_public_topbar_15')}}</el-button>
        <el-button size="small" @click="close_item_dialog">{{$t('view_public_topbar_14')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import i18n from '../../language/index'

import { staticRule, chineseRule } from "@/base/valid";
import {lockScroll, getStaticStr} from '@/base/base'
import seo from '../basic_common/seo.vue';
import {
  save_anchor,
  get_anchor,
  addNav,
  navList,
  deleteNav,
  navDetail,
  topNavList,
  quickSwitch,
  updateNav,
  pageNovlist,
  copyNav
} from '@/api/app.js';

export default {
  props: {
    showTag: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      titleWords: i18n.t('components_my_navbar_index_2371'),
      editType: '',
      colEditType: '', //
      navVisible: this.showTag,
      rules: {
        title: [
          {
            required: true,
            message: i18n.t('components_my_navbar_index_2389'),
            trigger: 'blur'
          },
          {
            min: 1,
            max: 60,
            message: i18n.t('components_my_navbar_index_2390'),
            trigger: 'blur'
          },
          {
            validator: chineseRule,
            trigger: "blur"
          }
        ],
        pageName: [
          {
            required: true,
            message: i18n.t('components_my_navbar_index_2391'),
            trigger: 'blur'
          },
          {
            min: 1,
            max: 20,
            message: i18n.t('components_my_navbar_index_2392'),
            trigger: 'blur'
          }
        ],
        link: [
          {
            required: true,
            message: i18n.t('components_my_navbar_index_2382'),
            trigger: 'blur'
          }
        ],
        static: [{
          max: 80,
          message: i18n.t('components_basic_addarticle_message_2025'),
        }, {
          validator: staticRule,
          trigger: 'blur'
        }],
        other_name: [
          {
            min: 0,
            max: 40,
            message: i18n.t('components_my_navbar_index_2393'),
            trigger: 'blur'
          }
        ],
      },
      count: 0,
      sysVersion: 3,
      tabList: [],
      tableData: this.$store.state.app.navListData ? this.$store.state.app.navListData : [],
      dialogFormVisible: false,
      //编辑id
      editId: '',
      autoSeo: {
        title: '',
        keywords: '',
        description: ''
      },
      handerSeo: {
        title: '',
        keywords: '',
        description: ''
      },
      childshowlist: [],
      basetabList: [],
      selectList: {},
      index: {
        parent: '',
        child: ''
      },
      activeName: 'first',
      loading: false,
      loading2: false,
      ruleForm: {
        children: [],
        pageType: 'page',
        pageName: '',
        link: '',
        title: '',
        name: '',
        hidden: 'false',
        window: 'false',
        sort: 0,
        nofollow: 1,
        radioSet: 2,
        pid: '',
        module: '',
        static: '',
        seo: {
          seo_title: '',
          seo_keywords: [],
          seo_description: ''
        },
        scroll_type: 'normal',
        isNotSystem: true
      },
      isResetTableData: true,
      navVisibleDisabled: true,
      isResetRuleForm: true,
      ruleFormDisabled: true
    };
  },
  components: {
    seo
  },
  watch: {
    navVisible (val, oldVal) {
      this.$emit('update:showTag', val);
    },
    showTag (val) {
      // 数据双向绑定
      this.navVisible = val;
      this.Re_binding();
    },
    ruleForm: {
      handler (val) {
        if (!this.isResetRuleForm) {
          this.ruleFormDisabled = false
        } else {
          this.ruleFormDisabled = true
          this.isResetRuleForm = false
        }
      },
      deep: true
    },
    tableData: {
      handler (val) {
        if (!this.isResetTableData) {
          this.navVisibleDisabled = false
        } else {
          this.navVisibleDisabled = true
          this.isResetTableData = false
        }
      },
      deep: true
    }
  },
  computed: {
    langType () {
      return this.$store.state.app.language
    },
    shouldScrollTypeShow () {
      console.log(this.ruleForm)
      let isNonIndependentPage = this.ruleForm.pid && ['article', 'product', 'case'].includes((this.ruleForm.module || '').split(':')[0])
      let isPage = this.ruleForm.pageType !== 'link'

      return isPage && !isNonIndependentPage && this.canEditScrollType
    },
    canEditScrollType () {
      return this.$store.state.app.role === 'designer' || this.colEditType === 'add' || this.ruleForm.isNotSystem === true
    }
  },
  mounted () {
    lockScroll(true)
    if (!this.ruleForm.scroll_type) {
      this.$set(this.ruleForm, 'scroll_type', this.ruleForm.scroll_type || 'normal')
    }
    if (typeof this.ruleForm.icon == 'undefined') {
      this.$set(this.ruleForm, 'icon', '')
      this.$set(this.ruleForm, 'other_name', '')
    }
    // this.Re_binding();
    // this.sort_Prompt_init();
    this.getNavList();
    this.getTopNavList();
  },
  methods: {
    add_keywords() {
      this.ruleForm.seo.keywords.push({value: ''})
    },
    del_keywords(index) {
      this.ruleForm.seo.keywords.splice(index,1)
    },
    isSystem(str) {
      return str.indexOf('p:') !== 0 && str !== 'index:index' && str !== 'anchor' && str !== '' ? true : false
    },
    delImg () {
      this.ruleForm.icon = null
    },
    showpop () {
      const that = this;
      this.$store.commit('image_upload/set_fileType', 1);
      this.$store.commit('image_upload/set_showTag', true);
      this.$store.commit('image_upload/set_fileLimit', 1);
      this.$store.state.image_upload.imgFile = e => {
        if (e && e instanceof Array && e.length > 0) {
          this.ruleForm.icon = e[0].filePath;
        }
        that.$store.state.image_upload.imgFile = null;
      };
    },
    closePop () {
      if (this.$store.state.app.is_change) {
        this.$confirm(i18n.t('components_my_navbar_index_2394'), '', {
          confirmButtonText: i18n.t('components_my_anchor_set_index_2236'),
          cancelButtonText: i18n.t('view_public_topbar_11'),
          type: 'warning'
        })
          .then(() => {
            this.templet.p_save(this.pageNovlist());
          })
          .catch(() => {
          });
      } else {
        this.$confirm(i18n.t('components_my_navbar_index_2395'), '', {
          confirmButtonText: i18n.t('components_my_anchor_set_index_2236'),
          cancelButtonText: i18n.t('view_public_topbar_11'),
          type: 'warning'
        })
          .then(() => {
            this.pageNovlist();
          })
          .catch(() => {
          });
      }
      // this.pageNovlist()
      // this.$store.state.myRender.common.setting.headerNavRadio = false
      this.$nextTick(() => {
        // window.location.reload()
        // this.$store.state.myRender.common.setting.headerNavRadio = true
      })
    },
    changeChildBack (parIndex, chIndex, data) {
      if (!data.children) {
        data.children = [];
      }
      if(!this.isSystem(data.module)
        || data.module == 'product'
        || data.module == 'article'
        || data.module == 'case') {
      this.tableData[parIndex].children.splice(chIndex, 1);
      this.tableData.splice(parIndex + 1, 0, data);
      this.Re_binding();
      } else {
        this.$message.error(i18n.t('components_my_navbar_index_2396'))
        return
      }
    },
    changeChildBottom (parIndex, chIndex, data) {
      this.tableData[parIndex].children.splice(chIndex, 1);
      this.tableData[parIndex].children.splice(chIndex + 1, 0, data);
      this.Re_binding();
    },
    changeChildTop (parIndex, chIndex, data) {
      this.tableData[parIndex].children.splice(chIndex, 1);
      this.tableData[parIndex].children.splice(chIndex - 1, 0, data);
      this.Re_binding();
    },
    changeChild2Bottom (parIndex, childIndex, chIndex, data) {
      this.tableData[parIndex].children[childIndex].children.splice(chIndex, 1);
      this.tableData[parIndex].children[childIndex].children.splice(chIndex + 1, 0, data);
      this.Re_binding();
    },
    changeChild2Top (parIndex, childIndex, chIndex, data) {
      this.tableData[parIndex].children[childIndex].children.splice(chIndex, 1);
      this.tableData[parIndex].children[childIndex].children.splice(chIndex - 1, 0, data);
      this.Re_binding();
    },
    changeChild2Back (parIndex, childIndex, chIndex, data) {
      if (!data.children) {
        data.children = [];
      }
      this.tableData[parIndex].children[childIndex].children.splice(chIndex, 1);
      this.tableData[parIndex].children.splice(chIndex + 1, 0, data);
      this.Re_binding();
    },
    changeParentRight (data, index) {
      this.tableData[index - 1];
      const drag_target  = this.tableData[index - 1]
      const drag_object  = this.tableData[index]
      console.log('拖拽目的页面：',this.tableData[index - 1])
      console.log('拖拽的页面：',this.tableData[index])
        //父为系统页面
      if (this.isSystem(drag_target.module)) {
        let module = drag_object.module
        if(drag_object.module.indexOf(':') > -1) {
          module = drag_object.module.substr(0, drag_object.module.indexOf(':'))
        }
        if(this.childIsNotSystem(drag_object)) {
            this.$message.error(i18n.t('components_my_navbar_index_2397'))
            return false
        }
        //子为单页面
        if (!this.isSystem(drag_object.module)) {
          // this.$message.error('单页面不可为系统页面的子级')
          // return false;
          this.tableData.splice(index, 1);
          this.tableData[index - 1].children.push(data);
          this.Re_binding();
        } else if (this.tableData[index].module == module) {
          this.tableData.splice(index, 1);
          this.tableData[index - 1].children.push(data);
          this.Re_binding();
        } else {
          this.$message.error(i18n.t('components_my_navbar_index_2398'))
          return false
        }
        //父为单页面
      } else {
        if (this.isSystem(drag_object.module)) {
          this.$message.error(i18n.t('components_my_navbar_index_2399'))
          return false
        } else {
          this.tableData.splice(index, 1);
          this.tableData[index - 1].children.push(data);
          this.Re_binding();
        }
      }
    },
    changeChildRight (parentIndex, data, index) {
      const drag_target  = this.tableData[parentIndex]
      const drag_object  = data
      console.log('拖拽目的页面：',drag_target)
      console.log('拖拽的页面：',drag_object)
      // 父为系统页面 module： anchor 锚点； '' 链接； p:开头或index:index 单页面，其他为系统页面
      if(this.isSystem(drag_target.module)) {
        if(!this.isSystem(drag_object.module)) {
            this.$message.error(i18n.t('components_my_navbar_index_2400'))
            return false
        }
      }
      this.tableData[parentIndex].children.splice(index, 1);
      this.tableData[parentIndex].children[index - 1].children.push(data);
      this.Re_binding();
    },
    changeParentBottom (data, index) {
      this.tableData.splice(index, 1);
      this.tableData.splice(index + 1, 0, data);
      this.Re_binding();
    },
    changeParentTop (data, index) {
      this.tableData.splice(index, 1);
      this.tableData.splice(index - 1, 0, data);
      this.Re_binding();
    },
    changeChildshow (parentIndex, childIndex = null) {
      
      let tableData = this.tableData;
      let subData = childIndex == null ? tableData[parentIndex] : tableData[parentIndex].children[childIndex]
      // if (childIndex == null) {
      //   let dat =  tableData[parentIndex]
      //   tableData[parentIndex].childShow == 'false' ? (tableData[parentIndex].childShow = 'true') : (tableData[parentIndex].childShow = 'false');
      // } else {
      //   let dat =  tableData[parentIndex].children[childIndex]
      //   tableData[parentIndex].children[childIndex].childShow == 'false' ? (tableData[parentIndex].children[childIndex].childShow = 'true') : (tableData[parentIndex].children[childIndex].childShow = 'false');
      // }
      subData.childShow = (subData.childShow == 'false') ? 'true' : 'false'

      let tag = subData.id + subData.module
      if(subData.childShow == 'true'){
        this.childshowlist.push(tag)
      }else{
        let index = this.childshowlist.indexOf(tag); 
        if (index > -1) { 
            this.childshowlist.splice(index, 1); 
        }  
      }
      this.tableData = tableData;
    },
    pageNovlist () {
      let tableData = this.tableData;
      let postData = {
        navigation: []
      };
      for (let i = 0; i < tableData.length; i++) {
        let parentData = {
          id: tableData[i].tid ? tableData[i].tid : tableData[i].id,
          module: tableData[i].module,
          children: []
        };
        if (!tableData[i].children) {
          tableData[i].children = []
        }
        let childList = tableData[i].children;
        for (let j = 0; j < childList.length; j++) {
          let childData = {
            id: childList[j].tid ? childList[j].tid : childList[j].id,
            module: childList[j].module,
            children: []
          };
          let child2List = childList[j].children;
          for (let j2 = 0; j2 < child2List.length; j2++) {
            let child2Data = {
              id: child2List[j2].tid ? child2List[j2].tid : child2List[j2].id,
              module: child2List[j2].module,
              children: []
            };
            childData.children.push(child2Data);
          }
          parentData.children.push(childData);
        }
        postData.navigation.push(parentData);
      }
      if (postData.navigation.length != 0) {
        pageNovlist(postData)
          .then(res => {
            if (res.code == 200) {
              this.getOneLevelNavList()
              // this.$store.state.myRender.common.setting.headerNavRadio = false
            }
          })
          .catch(error => {
          })
          .finally(() => {
            // this.navVisible = false
            // this.$store.state.myRender.common.setting.headerNavRadio = true
            // window.location.reload()
          });
      }
    },
    Re_binding () {
      this.$nextTick(() => {
        this.pageNovlist();
        // if (this.sysVersion == 3) {
        //   this.parent_sortable();
        //   this.child_sortable();
        //   this.listDroppable();
        // }
      });
    },
    //排序隐藏的row显示
    row_show () {
      if ($('.Sortableitem_ing').length > 0) {
        $('.Sortableitem_ing').removeClass('Sortableitem_ing');
      }
    },
    hide_module (e) {
      $(e.target)
        .parents('.navTopline')
        .addClass('Sortableitem_ing');
      const layout_body_top =
        window.innerHeight * 0.15 +
        $('.el-dialog__header').height() +
        $('.tableDatapart').height() +
        60 +
        $('.linePart')
          .eq(that.index.parent)
          .position().top;
      const mouse_top = event.clientY - layout_body_top;
      this.create_sort_Prompt(mouse_top);
    },
    sort_Prompt_init () {
      const that = this;
      $('#navToppart').on('mouseup', '.sort_Prompt', function (e) {
        that.row_show();
        that.del_sort_Prompt();
      });
    },
    clearData () {
      // this.row_show();
      // this.del_sort_Prompt();
    },
    //创建row排序提示元素
    create_sort_Prompt (mouse_top) {
      console.log(mouse_top);
      //没有则创建
      if ($('.sort_Prompt').length === 0) {
        const dom = $(i18n.t('components_my_navbar_index_2401'));
        dom.css('top', mouse_top - 15 + 'px');
        dom.appendTo('#navToppart');
      }
    },
    //删除排序提示元素
    del_sort_Prompt () {
      if ($('.sort_Prompt').length > 0) {
        $('.sort_Prompt').remove();
      }
    },
    //父列表，点击赋值index
    mousedown_parentIndex: function (i, event) {
      // $(event.target)
      //   .parents('.navTopline')
      //   .addClass('Sortableitem_ing');
      // $(event.target)
      //   .parents('.navTopline')
      //   .siblings()
      //   .removeClass('Sortableitem_ing');
      // this.index.parent = i;
      // this.index.child = null;
    },
    mousedown_childIndex: function (parentIndex, childIndex, event) {
      // this.index.parent = parentIndex;
      // this.index.child = childIndex;
    },
    datacomplete (obj) {
      let dataLength = obj.children('li').length;
      let tableData = [];
      for (let i = 0; i < dataLength; i++) {
        let dataObj = {
          disabled: obj
            .children('li')
            .eq(i)
            .find('.disabled')
            .val(),
          icon: obj
            .children('li')
            .eq(i)
            .find('.icon')
            .val(),
          id: obj
            .children('li')
            .eq(i)
            .find('.id')
            .val(),
          tid: obj
            .children('li')
            .eq(i)
            .find('.tid')
            .val(),
          is_system: obj
            .children('li')
            .eq(i)
            .find('.is_system')
            .val(),
          isopenwindow: obj
            .children('li')
            .eq(i)
            .find('.isopenwindow')
            .val(),
          link: obj
            .children('li')
            .eq(i)
            .find('.link')
            .val(),
          module: obj
            .children('li')
            .eq(i)
            .find('.module')
            .val(),
          name: obj
            .children('li')
            .eq(i)
            .find('.name')
            .val(),
          nofol: obj
            .children('li')
            .eq(i)
            .find('.nofol')
            .val(),
          pid: obj
            .children('li')
            .eq(i)
            .find('.pid')
            .val(),
          seq: obj
            .children('li')
            .eq(i)
            .find('.seq')
            .val(),
          childShow: obj
            .children('li')
            .eq(i)
            .find('.childShow')
            .val(),
          other_name: obj
            .children('li')
            .eq(i)
            .find('.other_name')
            .val(),
          children: []
        };
        let childLength = obj
          .children('li')
          .eq(i)
          .children('.childPart')
          .children('li').length;
        for (let j = 0; j < childLength; j++) {
          let childNode = obj
            .children('li')
            .eq(i)
            .children('.childPart')
            .children('li')
            .eq(j);
          let childObj = {
            disabled: childNode.find('.disabled').val(),
            icon: childNode.find('.icon').val(),
            id: childNode.find('.id').val(),
            tid: childNode.find('.tid').val(),
            is_system: childNode.find('.is_system').val(),
            isopenwindow: childNode.find('.isopenwindow').val(),
            link: childNode.find('.link').val(),
            module: childNode.find('.module').val(),
            name: childNode.find('.name').val(),
            nofol: childNode.find('.nofol').val(),
            pid: childNode.find('.pid').val(),
            seq: childNode.find('.seq').val(),
            children: [],
            childShow: childNode.find('.childShow').val(),
            other_name: childNode.find('.other_name').val(),
          };
          let child2Length = childNode
          .children('li')
          .eq(i)
          .children('.child2Part')
          .children('li').length;
          for (let q = 0; q < child2Length; q++) {
            let child2Node = childNode
              .children('li')
              .eq(i)
              .children('.child2Part')
              .children('li')
              .eq(j);
            let child2Obj = {
              disabled: child2Node.find('.disabled').val(),
              icon: child2Node.find('.icon').val(),
              id: child2Node.find('.id').val(),
              tid: child2Node.find('.tid').val(),
              is_system: child2Node.find('.is_system').val(),
              isopenwindow: child2Node.find('.isopenwindow').val(),
              link: child2Node.find('.link').val(),
              module: child2Node.find('.module').val(),
              name: child2Node.find('.name').val(),
              nofol: child2Node.find('.nofol').val(),
              pid: child2Node.find('.pid').val(),
              seq: child2Node.find('.seq').val(),
              children: [],
              childShow: 'false',
              other_name: child2Node.find('.other_name').val(),
            };
            childObj.children.push(child2Obj);
          }
          dataObj.children.push(childObj);
        }
        tableData.push(dataObj);
      }
      return tableData;
    },
    childIsNotSystem(data) {
      let result = false
      if(data.children && data.children.length > 0) {
          for(let i= 0; i < data.children.length;i++) {
            if(!this.isSystem(data.children[i].module)) {
                result = true
                break
            }
          }
      }
      return result
    },
    isLevel(data) {
      let level = 1
      if(data.children && data.children.length > 0) {
          level = 2
          for(let i= 0; i < data.children.length;i++) {
            if(data.children[i].children && data.children[i].children.length > 0) {
                 level = 3
            }
          }
      }
      return level
    },
    // drag_target 拖拽到页面（父）  drag_object拖拽的页面（子）
    sortable_data(type="parent") {
      const that = this
      let myList = JSON.parse(JSON.stringify(that.tableData));
      let drag_object = myList[that.index.parent];
      if(type == 'child' && myList[that.index.parent].children[that.index.child]) {
          drag_object = myList[that.index.parent].children[that.index.child];
      }
      const drag_target = myList[that.selectIndex];
      let level_num = that.isLevel(drag_object) + 2
      if(type == 'child') {
          level_num = that.isLevel(drag_object) + that.isLevel(drag_target.children)
      }

        if(level_num > 4) {
            that.$message.error(i18n.t('components_my_navbar_index_2402'))
            return myList
        }
        // 父为系统页面
        if (that.isSystem(drag_target.module)) {
          var module = drag_target.module
          if(drag_target.module.indexOf(':') > -1) {
            module = drag_target.module.substr(0, drag_target.module.indexOf(':'))
          }
          if(that.childIsNotSystem(drag_object)) {
              that.$message.error(i18n.t('components_my_navbar_index_2403'))
              return myList
          }
          if(type == 'parent') {
              if (!that.isSystem(drag_object.module)) {
                myList[that.selectIndex].children.push(drag_object);
                myList.splice(that.index.parent, 1);
              } else if (drag_object.module == module) {
                myList[that.selectIndex].children.push(drag_object);
                myList.splice(that.index.parent, 1);
              } else {
                that.$message.error(i18n.t('components_my_navbar_index_2404'))
                return myList
              }
          } else {
            if(!that.isSystem(drag_object.module)
            || drag_object.module == 'product'
            || drag_object.module == 'article'
            || drag_object.module == 'case'
            ) {
              myList[that.index.parent].children.splice(that.index.child, 1);
              myList.splice(that.index.parent, 0, drag_object);
            } else {
               that.$message.error(i18n.t('components_my_navbar_index_2396'))
              return myList
            }
          }
          // 父为单页面
        } else {
          if (that.isSystem(drag_object.module)) {
            that.$message.error(i18n.t('components_my_navbar_index_2405'))
            return myList
          } else {
            if(type == 'parent') {
              myList[that.selectIndex].children.push(drag_object);
              myList.splice(that.index.parent, 1);
            } else {
              myList[that.index.parent].children.splice(that.index.child, 1);
              myList.splice(that.index.parent, 0, drag_object);
            }
          }
        }
        return myList
    },
    //父列表绑定排序
    parent_sortable () {
      const that = this;
      $('.navToppart').sortable({
        placeholder: 'paixu',
        handle: '.sortLine',
        axis: 'y',
        opacity: 0.3,
        cursor: 'move',
        cancel: '.no_draggable',
        // sort: function(event, ui) {
        //   //排序的是module
        //     const layout_body_top = window.innerHeight*.15+$('.el-dialog__header').height()+$('.tableDatapart').height()+60 + $('.linePart').eq(that.index.parent).position().top;
        //     const mouse_top = event.clientY - layout_body_top;
        //     //没有则创建
        //     that.create_sort_Prompt(mouse_top);

        //     //有了则改变位置
        //     if($('.sort_Prompt').length > 0){
        //       $('.sort_Prompt').css('top',mouse_top + 'px');
        //     }
        // },
        stop: function (e, ui) {
          // var navColumnList = $(this);
          that.del_sort_Prompt();
          var myList = [];
          // //1级进2级
          // debugger
          if (that.index.child == null && that.index.parent > -1 && that.selectIndex > -1 && that.index.parent !== that.selectIndex) {
            myList = that.sortable_data()
          } else {
            myList = that.datacomplete($('.navToppart'));
          }
          that.tableData = [];

          that.$nextTick(function () {
            that.tableData = myList;
            that.Re_binding();
          });
        }
      });
    },
    //子列表绑定排序
    child_sortable () {
      const that = this;
      $('.childPart').sortable({
        connectWith: '.navToppart',
        placeholder: 'neipaixu',
        axis: 'y',
        cursor: 'move',
        cancel: '.no_draggable',
        // sort: function(event, ui) {
        //   //排序的是module
        //     const layout_body_top = window.innerHeight*.15+$('.el-dialog__header').height()+$('.tableDatapart').height()+60 + $('.linePart').eq(that.index.parent).siblings().children('.navChildline').eq(that.index.child).position().top;
        //     const mouse_top = event.clientY - layout_body_top;
        //     console.log(mouse_top,111)
        //     //没有则创建
        //     that.create_sort_Prompt(mouse_top);

        //     //有了则改变位置
        //     if($('.sort_Prompt').length > 0){
        //       $('.sort_Prompt').css('top',mouse_top-15 + 'px');
        //     }
        // },
        stop: function (event, ui) {
          that.del_sort_Prompt();
          let myList = JSON.parse(JSON.stringify(that.tableData))
          if (that.index.child !== null
          && that.index.parent !== null
          && myList[that.index.parent].children[that.index.child]) {
            myList = that.sortable_data('child')
          }
          ui.item.remove();
          that.tableData = [];
          that.$nextTick(function () {
            //debugger;
            that.tableData = myList;
            that.Re_binding();
            //that.listArr = that.resetVal($('.navColumnList'));
            //that.listDroppable();
          });
        }
      });
    },
    listDroppable () {
      const that = this;
      // debugger;
      $('.navToppart')
        .find('.navTopline')
        .droppable({
          hoverClass: 'xuanfu',
          accept: '.dropLi',
          over: function (event, ui) {
            //that.cover = true;
            //如果有子元素了，就不能放置了
            // if (ui.draggable.find('.childPart').children().length > 0) {
            //   that.cover = false;
            // }
            //console.log('是否可被放置',that.cover)
            $('.neipaixu').css({
              background: '#f5f5f5',
              border: '1px #b5c8eb dashed'
            });
            $('.paixu').css({
              background: '#f5f5f5',
              border: '1px #b5c8eb dashed'
            });

            that.selectIndex = $(this).index('.navTopline');
          },
          out: function (event, ui) {
            // debugger
            //that.cover = false;
            $('.neipaixu').css({
              background: '#fff8a1',
              border: '1px #ff690a dashed'
            });
            $('.paixu').css({
              background: '#fff8a1',
              border: '1px #ff690a dashed'
            });
          }
        });
    },
    //切换page清空表单
    changePage (type) {
      this.ruleForm = {
        children: [],
        pageType: type,
        pageName: '',
        link: '',
        title: '',
        name: '',
        icon: '',
        other_name: '',
        sort: 0,
        hidden: 'false',
        window: 'false',
        nofollow: 1,
        radioSet: 2,
        pid: '',
        seo: {
          seo_title: '',
          seo_keywords: '',
          seo_description: ''
        },
        scroll_type: 'normal'
      };
      // this.$refs['ruleForm'].resetFields();
    },
    modelChange (val) {
      if (val == 2) {
        this.ruleForm.seo.keywords = this.handerSeo.keywords;
        this.ruleForm.seo.description = this.handerSeo.description;
        this.ruleForm.seo.title = this.handerSeo.title;
      } else {
        this.ruleForm.seo.keywords = this.autoSeo.keywords;
        this.ruleForm.seo.description = this.autoSeo.description;
        this.ruleForm.seo.title = this.autoSeo.title;
      }
    },
    changeHanderseo (type, val) {
      if (type == 'title') {
        this.handerSeo.title = val;
      } else if (type == 'keywords') {
        this.handerSeo.keywords = val;
      } else if (type == 'description') {
        this.handerSeo.description = val;
      }
    },
    setSeoSummary (data) {
      this.autoSeo.description = data;
      if (this.ruleForm.radioSet == 1) {
        this.ruleForm.seo.description = this.autoSeo.description;
      }
    },
    setSeoTitle (data) {
      this.autoSeo.title = data;
      this.autoSeo.keywords = data;
      if (this.ruleForm.radioSet == 1) {
        this.ruleForm.seo.seo_keywords = this.autoSeo.keywords;
        this.ruleForm.seo.seo_title = this.autoSeo.title;
      }
    },
    getTreeData (data) {
      data.forEach(item => {
        item.childShow = this.childshowlist.indexOf(item.id + item.module) > -1 ? 'true' : 'false';
        this.count = this.count + 1
        if (!item.children) {
          item.children = [];
        }
        if (item.show_in_nav === undefined || item.show_in_nav === null) {
          item.show_in_nav = 'true';
        }
        if (item.children && item.children.length > 0) {
          this.getTreeData(item.children)
        }
      })
      return data
    },
  getWebsiteSection(data) {
    let temp = []
    data.forEach(item => {
      if(item.module && !this.isSystem(item.module)) {
        temp.push({
          id: item.id,
          name: item.name,
          display_name: '',
          module: item.module
        })
      }
      if (item.children && item.children.length > 0) {
        item.children.forEach(child => {
          if(child.module && !this.isSystem(child.module)) {
            temp.push({
              id: child.id,
              name: child.name,
              display_name: '　|-',
              module: child.module
            })
          }
        })
      }
    })
    return temp
  },
  getOneLevelNavList() {
      navList().then(res => {
          if (res.code == 200) {
            this.$store.commit('app/set_twoLevelNavList', this.getWebsiteSection(res.data));
          }
        }).catch(err => {
          console.log(err);
        });
  },
    getNavList () {
      this.loading = true;
      navList()
        .then(res => {
          if (res.code == 200) {
            this.count = 0
            let data = this.getTreeData(res.data)
            this.tableData = data;
            this.$store.commit('app/set_navListData', data);
            this.$store.commit('app/set_twoLevelNavList', this.getWebsiteSection(res.data));
            this.$nextTick(() => {
              this.Re_binding();
            });
            this.loading = false;
          } else {
            this.loading = false;
            this.$message.error(res.message);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    changeSwitch (type, item) {
      let data = {
        switch: []
      };
      if (type == 'show_in_nav') {
        if (item.show_in_nav == 'true') {
          item.show_in_nav = 'false';
        } else {
          item.show_in_nav = 'true';
        }
        data.switch.push({
          id: item.tid ? item.tid : item.id,
          name: 'show_in_nav',
          value: item.show_in_nav,
          module: item.module
        });
      } else if (type == 'isopenwindow') {
        if (item.disabled == 'false') {
          item.disabled = 'true';
        } else {
          item.disabled = 'false';
        }
        let addData = {
          id: item.tid ? item.tid : item.id,
          name: type,
          value: item.isopenwindow,
          module: item.module
        };
        data.switch.push(addData);
      } else if (type == 'hide') {
        if (item.disabled == 'false') {
          item.disabled = 'true';
        } else {
          item.disabled = 'false';
        }
        let showInNavVal = item.disabled == 'true' ? 'false' : 'true';
        if (item.pid == 0) {
          data.switch.push({
            id: item.tid ? item.tid : item.id,
            name: type,
            value: item.disabled,
            module: item.module
          });
          item.show_in_nav = showInNavVal;
          data.switch.push({
            id: item.tid ? item.tid : item.id,
            name: 'show_in_nav',
            value: showInNavVal,
            module: item.module
          });
          for (let i = 0; i < item.children.length; i++) {
            let child = item.children[i];
            child.disabled = item.disabled;
            child.show_in_nav = showInNavVal;
            data.switch.push({
              id: child.tid ? child.tid : child.id,
              name: type,
              value: item.disabled,
              module: child.module
            });
            data.switch.push({
              id: child.tid ? child.tid : child.id,
              name: 'show_in_nav',
              value: showInNavVal,
              module: child.module
            });
          }
        } else {
          let parentData = {};
          for (let i = 0; i < this.tableData.length; i++) {
            if (this.tableData[i].id == item.pid) {
              parentData = this.tableData[i];
            }
          }
          data.switch.push({
            id: item.tid ? item.tid : item.id,
            name: type,
            value: item.disabled,
            module: item.module
          });
          item.show_in_nav = showInNavVal;
          data.switch.push({
            id: item.tid ? item.tid : item.id,
            name: 'show_in_nav',
            value: showInNavVal,
            module: item.module
          });
          if (parentData.disabled == 'true' && item.disabled == 'false') {
            parentData.disabled = 'false';
            parentData.show_in_nav = 'true';
            data.switch.push({
              id: parentData.tid ? parentData.tid : parentData.id,
              name: type,
              value: 'false',
              module: parentData.module
            });
            data.switch.push({
              id: parentData.tid ? parentData.tid : parentData.id,
              name: 'show_in_nav',
              value: 'true',
              module: parentData.module
            });
          }
        }
      }

      quickSwitch(data)
        .then(res => {
          if (res.code == 200) {
            this.getNavList();
          } else {
            this.getNavList();
            this.$message.error(res.message);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //栏目下拉列表
    getTopNavList () {
      topNavList()
        .then(res => {
          if (res.code == 200) {
            let data = res.data;
            this.basetabList = data;
            this.tabList = data;
          } else {
            this.$message.error(res.message);
          }
        })
        .catch(err => {
          console.log(err);
        }).finally(() => {
          if (this.editType) {
            this.ruleFormDisabled = true
          }
        });
    },
    staticBlur() {
      this.ruleForm.static = getStaticStr(this.ruleForm.static);
    },
    // 保存栏目
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        this.loading2 = true;
        let valid_seo = true;
        if(this.ruleForm.pageType == 'page'){       
          this.$refs.infoSeo.$refs.seo_data.validate(valid => {
            valid_seo = valid;
          });
        }
        if (valid && valid_seo) {
          let data = {
            pageType: this.ruleForm.pageType,
            title: this.ruleForm.title,
            icon: this.ruleForm.icon,
            other_name: this.ruleForm.other_name,
            hidden: this.ruleForm.hidden,
            nofollow: this.ruleForm.nofollow,
            window: this.ruleForm.window,
            pid: this.ruleForm.pid,
            sort: this.ruleForm.sort,
            scroll_type: this.ruleForm.scroll_type
          };

          if (this.ruleForm.pageType == 'page') {
            data.pageName = this.ruleForm.pageName;
            if (this.ruleForm.title && !this.ruleForm.static) {
              this.ruleForm.static = getStaticStr(this.ruleForm.title);
            }
            if (this.ruleForm.static) {
              this.ruleForm.static = getStaticStr(this.ruleForm.static);
            }
            data.static = this.ruleForm.static;
            if (this.ruleForm.seo.seo_keywords) {
              this.ruleForm.seo.seo_keywords.map(item=> {
                item.value = item.value.replace(/[\uff0c]/g, ",")
              })
            }
            (data.seo_title = this.ruleForm.seo.seo_title),
            (data.seo_keywords = this.ruleForm.seo.seo_keywords),
            (data.seo_description = this.ruleForm.seo.seo_description);
          } else {
            data.link = this.ruleForm.link;
          }
          //添加
          if (!this.editId) {
            addNav(data).then(res => {
              this.loading2 = false;
              if (res.code === 200) {
                if (this.titleWords == i18n.t('components_my_navbar_index_2406')) {
                  this.$message.success(i18n.t('components_ai_command_tkd_1979'));
                } else {
                  this.$message.success(i18n.t('components_my_navbar_index_2407'));
                }
                this.getNavList();
                this.dialogFormVisible = false;
              } else {
                this.$message.error(res.message);
              }
            });
          } else {
            data.id = this.editId;
            data.module = this.ruleForm.module;
            // if (data.id == data.pid) {
            //   this.$message.error('栏目分类不能选为当前单页本身！');
            //   this.loading2 = false;
            //   return false;
            // }
            // if (this.sysVersion == '2') {
            //   let parentData = {};
            //   for (let i = 0; i < this.tableData.length; i++) {
            //     if (this.tableData[i].id == data.pid) {
            //       parentData = this.tableData[i];
            //     }
            //   }
            //   if (data.pid && data.module && parentData.module) {
            //     if (data.module.indexOf('p:') != -1 && parentData.module.indexOf('p:') == -1) {
            //       this.$message.error('只有单页能成为单页的二级页面！');
            //       this.loading2 = false;
            //       return false;
            //     }
            //   }
            // }
            if (this.editType == 'edit') {
              updateNav(data).then(res => {
                this.loading2 = false;
                if (res.code === 200) {
                  this.$message.success(res.message);
                  this.getNavList();
                  this.dialogFormVisible = false;
                } else {
                  this.$message.error(res.message);
                }
              });
            } else {
              delete data.id
              delete data.pid
              delete data.module
              copyNav(data).then(res => {
                this.loading2 = false;
                if (res.code === 200) {
                  this.$message.success(res.message);
                  this.getNavList();
                  this.dialogFormVisible = false;
                } else {
                  this.$message.error(res.message);
                }
              });
            }
          }
        } else {
          this.$nextTick(() => {
              let isError = document.getElementsByClassName("is-error");
              if (isError.length > 0) {
                isError[0].scrollIntoView({
                  // 滚动到指定节点
                  // 值有start,center,end，nearest，当前显示在视图区域中间
                  block: "center",
                  // 值有auto、instant,smooth，缓动动画（当前是慢速的）
                  behavior: "smooth"
                });
                return false;
              }
          });
          this.loading2 = false;
          console.log('error submit!!');
        }
      });
    },
    //删除栏目
    deletePage (item) {
      this.$confirm(i18n.t('components_my_navbar_index_2408'), i18n.t('view_public_topbar_23'), {
        confirmButtonText: i18n.t('view_public_topbar_24'),
        cancelButtonText: i18n.t('view_public_topbar_11'),
        type: 'warning'
      })
        .then(() => {
          deleteNav({ id: item.id })
            .then(res => {
              if (res.code === 200) {
                this.$message.success(i18n.t('components_my_navbar_index_2409'));
                if (item.theme_name === 'anchor') {
                  //添加查找所有锚点的接口 遍历接口数据清除掉对应id的createNav = false
                  this.get_anchor(item.id)
                }
                this.getNavList();
              } else {
                this.$message.error(res.message);
              }
            })
            .catch(err => {
              console.log(err);
            });
        })
        .catch(() => {
        });
    },
    //获取所有锚点数据
    get_anchor (navID) {
      get_anchor()
        .then(res => {
          if (res.code === 200) {
            let anchor_data = res.data
            for (let i in anchor_data) {
              if (Array.isArray(anchor_data[i])) {
                anchor_data[i].map(e => {
                  if (e.navID == navID) {
                    e.navID = ''
                    e.createNav = false
                  }
                  return e
                })
              }
            }
            this.save_anchor(anchor_data)
          } else {
            this.$message.error(res.message);
          }
        })
        .catch(error => {
          this.$message.error(error)
        });
    },
    save_anchor (anchorData) {
      let data = {
        anchor: anchorData,
      }
      save_anchor(data)
        .then(res => {
          if (res.code == 200) {
            console.log('锚点数据保存成功')
          }
        })
        .catch(error => {
          this.$message.error(error);
        });
    },
    //查看详情
    showpoppart (item, type, isNotSystem) {
      this.colEditType = type
      if (!item) {
        this.colEditType = 'add'
      }
      //获取
      this.getTopNavList();
      if (type) {
        this.editType = type
      } else {
        this.editType = ''
      }
      if (item.id) {
        this.editId = item.tid ? item.tid : item.id;
        this.ruleForm.module = item.module;
        this.ruleForm.children = item.children;
        navDetail({
          id: this.editId,
          module: item.module
        })
          .then(res => {
            if (res.code == 200) {
              let data = res.data;
              //this.ruleForm.pageType = data.pageType;
              if (type == 'add') {
                this.editId = ''
                this.ruleForm = {
                  children: [],
                  pageType: 'page',
                  pageName: '',
                  link: '',
                  title: '',
                  name: '',
                  icon: '',
                  other_name: '',
                  hidden: 'false',
                  window: 'false',
                  nofollow: 1,
                  radioSet: 2,
                  pid: '',
                  seo: {
                    seo_title: '',
                    seo_keywords: [],
                    seo_description: ''
                  },
                  isNotSystem: true,
                  scroll_type: 'normal'
                }

                this.ruleForm.pid = data.id ? data.id : item.id ? item.id : '';
              } else {
                this.ruleForm.scroll_type = data.scroll_type;
                this.ruleForm.pageType = !data.module ? 'link' : 'page';
                if (type == 'copy') {
                  this.ruleForm.title = data.title + '(1)'
                  this.editId = ''
                  this.titleWords = i18n.t('components_my_navbar_index_2406')
                } else {
                  this.ruleForm.title = data.title;
                  this.titleWords = i18n.t('components_my_navbar_index_2410')
                }
                this.ruleForm.hidden = data.hidden;
                this.ruleForm.nofollow = data.nofollow;
                this.ruleForm.window = data.window;

                this.ruleForm.pid = data.pid ? data.pid : item.pid ? item.pid : '';
                let tag = false;
                for (let i = 0; i < this.tabList.length; i++) {
                }
                this.ruleForm.sort = data.sort;
                if (this.ruleForm.pageType == 'page') {
                  this.ruleForm.pageName = data.pageName;
                  // 对keywords进行设置
                  let seo_keywords = []
                  let keywordsList = data.seo_keywords.split(',')
                  if(data.seo_keywords !== null && data.seo_keywords.length !== 0 && keywordsList.length > 0) {
                    keywordsList.map(item=> {
                      seo_keywords.push({
                        value: item
                      })
                    })
                  } else {
                    seo_keywords = []
                  }
                  this.ruleForm.seo = {
                    seo_title: data.seo_title,
                    seo_keywords: seo_keywords,
                    seo_description: data.seo_description
                  };
                } else {
                  this.ruleForm.link = data.link;
                }
                this.ruleForm.icon = data.icon || ''
                this.ruleForm.other_name = data.other_name || ''
              }
              this.ruleForm.scroll_type = data.scroll_type || 'normal'
              this.ruleForm.isNotSystem = isNotSystem
              this.ruleForm.static = data.static
              this.dialogFormVisible = true;
            } else {
              this.$message.error(res.message);
            }
          })
          .catch(err => {
            console.log(err);
          }).finally(() => {
            if (this.editType) {
              this.ruleFormDisabled = true
            }
          });
      } else {
        //添加
        this.titleWords = i18n.t('components_my_navbar_index_2371')
        this.editId = '';
        this.ruleForm = {
          children: [],
          pageType: 'page',
          pageName: '',
          link: '',
          title: '',
          name: '',
          icon: '',
          other_name: '',
          hidden: 'false',
          window: 'false',
          nofollow: 1,
          radioSet: 2,
          pid: '',
          seo: {
            seo_title: '',
            seo_keywords: [],
            seo_description: ''
          },
          scroll_type: 'normal',
          isNotSystem: true
        };
        this.dialogFormVisible = true;
      }
      this.isResetRuleForm = true
    },
    close_dialog () {
      this.navVisible = true
      if (!this.navVisibleDisabled) {
        this.$confirm(i18n.t('components_my_navbar_index_2411'), {
          confirmButtonText: i18n.t('view_public_topbar_24'),
          cancelButtonText: i18n.t('view_public_topbar_11'),
          type: 'warning'
        }).then(() => {
          // 不保存退出
          this.navVisible = false
          this.$nextTick(()=> {
            lockScroll(false)
          })
          window.location.reload()
        }).catch(() => {
          // 啥也不做
        })
      } else {
        this.navVisible = false
        this.$nextTick(()=> {
          lockScroll(false)
        })
      }
    },
    close_item_dialog () {
      this.dialogFormVisible = true
      if (!this.ruleFormDisabled) {
        this.$confirm(i18n.t('view_dialog_index_170'), {
          confirmButtonText: i18n.t('view_public_topbar_24'),
          cancelButtonText: i18n.t('view_public_topbar_11'),
          type: 'warning'
        }).then(() => {
          // 不保存退出
          this.dialogFormVisible = false
        }).catch(() => {
          // 啥也不做
        })
      } else {
        this.dialogFormVisible = false
      }
    },
    onClickScrollType (item) {
      this.ruleForm.scroll_type = item.value
      // this.$set(this.ruleForm, 'scroll_type', item.value)
    },
    onMouseEnter (item, type) {
      let urlMap = {
        'normal': '/static/image/fullpage/scroll_page_normal.gif',
        'col': '/static/image/fullpage/scroll_page_col.gif',
        'row': '/static/image/fullpage/scroll_page_row.gif',
      }
      let url = urlMap[item.value]
      // 新增属性直接赋值 视图没有自动更新
      this.$set(item, 'sampleImgVisible', true)
      this.$set(item, 'sampleImgUrl', url)
    },
    onMouseLeave (item) {
      this.$set(item, 'sampleImgVisible', false)
    },
  }
};
</script>

<style scoped type="text/css" lang="scss">
.my_navbar {
  /deep/ .el-dialog__footer {
    .dialog-footer {
      text-align: center;

      .el-button {
        margin: 8px 18px;
      }
    }
  }
}

.navToppart {
  position: relative;
  height: 350px;
  overflow-y: auto;
  border-bottom: 1px solid #efefef;

  .navTopline {
    width: 100%;
    background-color: #fff;

    .linePart {
      font-size: 0;
      border-bottom: 1px solid #ebeef5;

      .contentPart {
      }

      > div {
        text-align: center;
        display: inline-block;
        line-height: 36px;
        padding: 7px 0;
        font-size: 14px;
        position: relative;

        span {
          width: 100%;
          line-height: 36px;
          display: block;
          text-align: left;
          margin-left: 27px;
        }

        .deleteIcon {
          width: 15px;
          height: 15px;
          cursor: pointer;
          background: url("../../assets/nav_icon/delete-icon.png");
        }

        .disdeleteIcon {
          width: 15px;
          height: 15px;
          cursor: not-allowed;
          background: url("../../assets/nav_icon/disdelete-icon.png");
        }

        .editIcon {
          width: 15px;
          height: 15px;
          cursor: pointer;
          background: url("../../assets/nav_icon/edit-icon.png");
        }

        .diseditIcon {
          width: 15px;
          height: 15px;
          cursor: pointer;
          background: url("../../assets/nav_icon/disedit-icon.png");
        }

        .addIcon {
          width: 15px;
          height: 15px;
          cursor: pointer;
          background: url("../../assets/nav_icon/add-icon.png");
        }

        .disaddIcon {
          width: 15px;
          height: 15px;
          cursor: pointer;
          background: url("../../assets/nav_icon/disadd-icon.png");
        }

        .copyIcon {
          width: 15px;
          height: 15px;
          cursor: pointer;
          background: url("../../assets/nav_icon/copy-icon.png");
        }

        .discopyIcon {
          width: 15px;
          height: 15px;
          cursor: not-allowed;
          background: url("../../assets/nav_icon/discopy-icon.png");
        }

        .stopPart {
          cursor: pointer;
          position: absolute;
          left: 7px;
          top: 0;
          z-index: 9999;
          height: 50px;
          line-height: 50px;
          width: 20px;
          display: block;
        }

        em {
          text-align: center;
          padding: 0 10px;
          cursor: pointer;
        }

        .el-icon-btn {
          cursor: pointer;
          display: inline-block;
          width: 8px;
          height: 13px;
          margin-right: 10px;
          color: #999;

          a {
            color: #999;
          }
        }

        .el-icon-btn:hover a {
          color: #999;
          background-color: #f4f4f4;
        }
      }

      .contorlPart {
        .iconPart {
          display: inline-block;
          margin: 0 5px;
        }

        span {
          margin: unset;
          display: inline-block;
        }
      }
    }
  }
}

.childPart {
  .stopPart {
    cursor: pointer;
    position: absolute;
    left: 7px;
    top: 0;
    z-index: 9999;
    height: 50px;
    line-height: 50px;
    width: 20px;
    display: block;
  }
  .navChildline {
    padding-left: 20px;
  }
}

// .dropLi {
//   cursor: move;
// }

.navChildline {
  width: 100%;
  background-color: #fff;

  .childLinepart {
    font-size: 0;
    border-bottom: 1px solid #ebeef5;
    > div {
      text-align: center;
      display: inline-block;
      line-height: 36px;
      padding: 7px 0;
      font-size: 14px;
      position: relative;

      span {
        width: 100%;
        line-height: 36px;
        display: block;
        text-align: left;
        margin-left: 27px;
      }

      .deleteIcon {
        width: 15px;
        height: 15px;
        cursor: pointer;
        background: url("../../assets/nav_icon/delete-icon.png");
      }

      .disdeleteIcon {
        width: 15px;
        height: 15px;
        cursor: not-allowed;
        background: url("../../assets/nav_icon/disdelete-icon.png");
      }

      .disaddIcon {
        width: 15px;
        height: 15px;
        cursor: pointer;
        background: url("../../assets/nav_icon/disadd-icon.png");
      }

      .editIcon {
        width: 15px;
        height: 15px;
        cursor: pointer;
        background: url("../../assets/nav_icon/edit-icon.png");
      }

      .diseditIcon {
        width: 15px;
        height: 15px;
        cursor: pointer;
        background: url("../../assets/nav_icon/disedit-icon.png");
      }

      .addIcon {
        width: 15px;
        height: 15px;
        cursor: pointer;
        background: url("../../assets/nav_icon/add-icon.png");
      }

      .copyIcon {
        width: 15px;
        height: 15px;
        cursor: pointer;
        background: url("../../assets/nav_icon/copy-icon.png");
      }

      .discopyIcon {
        width: 15px;
        height: 15px;
        cursor: not-allowed;
        background: url("../../assets/nav_icon/discopy-icon.png");
      }

      em {
        text-align: center;
        padding: 0 10px;
        cursor: pointer;
      }

      .el-icon-btn {
        cursor: pointer;
        display: inline-block;
        width: 8px;
        height: 13px;
        margin-right: 10px;
        color: #999;

        a {
          color: #999;
        }
      }

      .el-icon-btn:hover a {
        color: #999;
        background-color: #f4f4f4;
      }
    }

    .contorlPart {
      .iconPart {
        display: inline-block;
        margin: 0 5px;
      }

      span {
        margin: unset;
        display: inline-block;
      }
    }
  }
}

.tableData {
  border-left: 1px solid #ebeef5;
  border-right: 1px solid #ebeef5;
}

.tableData /deep/ .paixu {
  width: 100%;
  height: 65px;
  background: #fff8a1;
  border: 1px #e3c818 dashed;
  margin-bottom: 7px;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
}

.tableData /deep/ .neipaixu {
  width: 100%;
  height: 65px;
  background: #fff8a1;
  border: 1px #e3c818 dashed;
  margin-bottom: 10px;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
}

.tableData .xuanfu {
  box-shadow: 5px 5px 5px #666;
  border: 1px #0026ff solid;
}

/deep/ .sort_Prompt {
  position: absolute;
  width: 100%;
  height: 64px;
  background: #477eff;
  text-align: center;
  line-height: 64px;
  color: #fff;
  top: 0;
  left: 0;
  z-index: 999999;
}

.mySortableModule {
  width: 375px;
  height: 30px;
  background: #ffe5cd;
  border: 1px #ec6941 dashed;
  list-style: none;
}

.mySortableModule:before {
  content: "放这里";
  display: block;
  width: 100%;
  height: 100%;
  color: #ec6941;
  text-align: center;
  line-height: 30px;
}

.mySortableModule span {
  display: block;
  width: 100%;
  height: 100%;
  color: #ec6941;
  text-align: center;
  line-height: 30px;
}

/deep/ .Sortableitem_ing {
  height: 64px;
  overflow: hidden;
}

.contentLine {
  width: 100%;
  height: 64px;
}

.tableData {
  .headerLine {
    font-size: 0;
    height: 36px;
    line-height: 36px;
    background-color: #fafafa;

    span {
      font-size: 16px;
      display: inline-block;
      text-align: center;
    }

    .firstLine {
      text-align: left;
      margin-left: 27px;
      width: 220px;
    }
  }

  .ce_1 {
    width: 194px;
  }

  .ce_2 {
    width: 80px;
  }

  .ce_2_show {
    width: 80px;
  }

  .ce_3 {
    width: 160px;
  }

  .ce_4 {
    width: 195px;
  }
}

.countPart {
  text-align: left;
  line-height: 14px;
  font-size: 14px;
  padding-top: 18px;
}

.bottomBtn {
  text-align: center;
  padding-top: 30px;
}

.determineBtn {
  width: 104px;
  color: #fff;
  background-color: #4c556d;
  border: 1px solid #4c556d;
}

.switch-icon {
  .el-icon-check {
    color: #7dc343;
  }

  .el-icon-close {
    color: #da4539;
  }
}

.ruleFormStyle {
  max-height: 500px;
  overflow-y: auto;
}

/deep/ .el-form-item__content {
  min-width: 300px;
  font-size: 14px;
}

.describe {
  display: block;
  font-size: 12px;
  color: #999;
  line-height: 1.5;
  padding: 8px 0;
}

.add_type .el-form-item__label {
  width: 79px;
}

.add_type .el-form-item__content {
  margin-left: 84px;
}

.el-alert--warning {
  width: 910px;
}

.el-form .el-form-item__label {
  width: 154px !important;
}

.add0 .el-form-item__label {
  width: 152px !important;
}

.seotipswords {
  display: block;
  font-size: 12px;
  color: #999;
  line-height: 2;
}

.el-select .el-input .el-select__caret {
  color: #c0c4cc;
  font-size: 14px;
  transition: transform 0.3s;
  transform: rotate(180deg);
  cursor: pointer;
}

.area input::-webkit-input-placeholder {
  color: #606266;
}

.formItem .el-form-item__label:before {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
}

.step_1,
.step_2 {
  padding: 0;
}

.step_1 .el-form-item__content .el-input,
.step_2 .el-form-item__content .el-input,
.step_1 .el-form-item__content .el-select,
.step_2 .el-form-item__content .el-textarea {
  width: 440px;
  font-size: 12px;
}

.step_1 .el-form-item__content .el-input /deep/ .el-input__inner,
.step_2 .el-form-item__content .el-input /deep/ .el-input__inner,
.step_1 .el-form-item__content .el-select /deep/ .el-input__inner {
  height: 34px;
  line-height: 34px;
}

.addNavPart {
  height: 70px;

  .title {
    font-size: 14px;
    line-height: 70px;
    color: #666;
    float: left;
  }

  .el-button {
    float: right;
    margin: 19px 0;
  }
}

.setting-scroll-type {
  width: 400px;
  line-height: 1;

  .style_item_img {
    width: 118px;
    height: 78px;
  }

  .style_item_img.style_item_0 {
    background: url("/static/image/fullpage/scroll_page_normal.png") no-repeat;
  }

  .style_item_img.style_item_1 {
    background: url("/static/image/fullpage/scroll_page_col.png") no-repeat;
  }

  .style_item_img.style_item_2 {
    background: url("/static/image/fullpage/scroll_page_row.png") no-repeat;
  }
}
.avatar-uploader-part-new {
  cursor: pointer;
  display: inline-block;
  margin-right: 15px;
  margin-bottom: 15px;
  position: relative;
  vertical-align: top;
  border: 1px solid #e7e7eb;
  text-align: center;
  border-radius: 6px;
  width: 84px;
  height: 84px;
  .close-avatar-uploader {
    font-size: 14px;
    position: absolute;
    top: -6px;
    right: -6px;
    color: #dd0000;
    background: #fff;
    display: none;
    border-radius: 50%;
  }
  img {
    display: inline-block;
    max-width: 100%;
    height: 100%;
    vertical-align: middle;
    -o-object-fit: contain;
    object-fit: contain;
    border: 1px solid transparent;
  }
}
.avatar-uploader-part-new:hover .close-avatar-uploader {
  display: block;
}

.el-form-self-check {
  .el-form-item.is-error {
    margin-bottom:35px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/my_navbar/index.vue